import { useNavigate } from 'react-router';

import { APP_PATH } from '@shared/config';
import { StatusScreen } from '@shared/ui/status-screen';

import { NOT_FOUND_TEXT } from '../config/not-found.text';

/**
 * "화면을 찾을 수 없습니다" 본문(StatusScreen kind=not-found, Figma `2143:25089`). 버튼은 "처음으로" 하나(DD-16 C3).
 * S21 페이지 없음과, 주소의 대상(펀드 · 포트폴리오)이 없거나 볼 수 없는 상세 화면이 같이 쓴다.
 */
export function NotFoundScreen() {
  const navigate = useNavigate();
  return (
    <StatusScreen
      inline
      title={NOT_FOUND_TEXT.title}
      description={NOT_FOUND_TEXT.description}
      action={{ label: NOT_FOUND_TEXT.goHome, onClick: () => void navigate(APP_PATH.root) }}
    />
  );
}
